module.exports = __webpack_public_path__ + "static/media/Icon_7.934b370b.svg";